export const lightIcon = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 19.839L10.5 18.089L14 19.839V11.502C13.0385 12.3646 11.7917 12.8408 10.5 12.839C9.20826 12.8408 7.96154 12.3646 7 11.502V19.839Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 7.58899C15.7508 8.32776 15.5953 9.05834 15.2937 9.73274C14.9921 10.4071 14.5512 11.0101 14 11.502C13.0385 12.3646 11.7917 12.8408 10.5 12.839C9.20826 12.8408 7.96154 12.3646 7 11.502C6.4488 11.0101 6.00792 10.4071 5.70631 9.73274C5.4047 9.05834 5.24919 8.32776 5.25 7.58899C5.25 4.68968 7.60069 2.33899 10.5 2.33899C13.3993 2.33899 15.75 4.68968 15.75 7.58899Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 9.77649V5.40149L9.625 5.83899M10.5 9.77649H11.375M10.5 9.77649H9.625"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const shopIcon = (isActive) => {
  const strokeColor = isActive ? "white" : "black";

  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6364 5.02844H3.36364C3.13459 5.02844 2.91492 5.11695 2.75295 5.27449C2.59099 5.43203 2.5 5.6457 2.5 5.8685V9.22873C2.5015 9.74868 2.6683 10.2554 2.97754 10.6796C3.28677 11.1037 3.7233 11.4244 4.22727 11.5977V19.3094C4.22727 19.5322 4.31826 19.7459 4.48023 19.9034C4.64219 20.061 4.86186 20.1495 5.09091 20.1495H18.9091C19.1381 20.1495 19.3578 20.061 19.5198 19.9034C19.6817 19.7459 19.7727 19.5322 19.7727 19.3094V11.5977C20.2767 11.4244 20.7132 11.1037 21.0225 10.6796C21.3317 10.2554 21.4985 9.74868 21.5 9.22873V5.8685C21.5 5.6457 21.409 5.43203 21.247 5.27449C21.0851 5.11695 20.8654 5.02844 20.6364 5.02844ZM14.5909 6.70856H16.3182V9.22873C16.3182 9.45153 16.2272 9.6652 16.0652 9.82274C15.9033 9.98028 15.6836 10.0688 15.4545 10.0688C15.2255 10.0688 15.0058 9.98028 14.8439 9.82274C14.6819 9.6652 14.5909 9.45153 14.5909 9.22873V6.70856ZM11.1364 6.70856H12.8636V9.22873C12.8636 9.45153 12.7726 9.6652 12.6107 9.82274C12.4487 9.98028 12.2291 10.0688 12 10.0688C11.7709 10.0688 11.5513 9.98028 11.3893 9.82274C11.2274 9.6652 11.1364 9.45153 11.1364 9.22873V6.70856ZM7.68182 6.70856H9.40909V9.22873C9.40909 9.45153 9.3181 9.6652 9.15614 9.82274C8.99417 9.98028 8.77451 10.0688 8.54545 10.0688C8.3164 10.0688 8.09674 9.98028 7.93477 9.82274C7.77281 9.6652 7.68182 9.45153 7.68182 9.22873V6.70856ZM5.09091 10.0688C4.86186 10.0688 4.64219 9.98028 4.48023 9.82274C4.31826 9.6652 4.22727 9.45153 4.22727 9.22873V6.70856H5.95455V9.22873C5.95455 9.45153 5.86356 9.6652 5.70159 9.82274C5.53963 9.98028 5.31996 10.0688 5.09091 10.0688ZM13.7273 18.4694H10.2727V16.7892C10.2727 16.3437 10.4547 15.9163 10.7786 15.6012C11.1026 15.2861 11.5419 15.1091 12 15.1091C12.4581 15.1091 12.8974 15.2861 13.2214 15.6012C13.5453 15.9163 13.7273 16.3437 13.7273 16.7892V18.4694ZM18.0455 18.4694H15.4545V16.7892C15.4545 15.8981 15.0906 15.0434 14.4427 14.4132C13.7949 13.783 12.9162 13.429 12 13.429C11.0838 13.429 10.2051 13.783 9.55727 14.4132C8.90941 15.0434 8.54545 15.8981 8.54545 16.7892V18.4694H5.95455V11.5977C6.27199 11.4831 6.56483 11.3122 6.81818 11.0937C7.2932 11.5069 7.90815 11.7354 8.54545 11.7354C9.18276 11.7354 9.79771 11.5069 10.2727 11.0937C10.7477 11.5069 11.3627 11.7354 12 11.7354C12.6373 11.7354 13.2523 11.5069 13.7273 11.0937C14.2023 11.5069 14.8172 11.7354 15.4545 11.7354C16.0919 11.7354 16.7068 11.5069 17.1818 11.0937C17.4352 11.3122 17.728 11.4831 18.0455 11.5977V18.4694ZM19.7727 9.22873C19.7727 9.45153 19.6817 9.6652 19.5198 9.82274C19.3578 9.98028 19.1381 10.0688 18.9091 10.0688C18.68 10.0688 18.4604 9.98028 18.2984 9.82274C18.1364 9.6652 18.0455 9.45153 18.0455 9.22873V6.70856H19.7727V9.22873Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export const personalInfoIcon = (isActive) => {
  const strokeColor = isActive ? "white" : "black";

  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5011 20.3617V18.6344C21.5005 17.869 21.2457 17.1254 20.7768 16.5205C20.3078 15.9155 19.6513 15.4835 18.9102 15.2921"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3182 20.3617V18.6345C16.3182 17.7183 15.9542 16.8396 15.3064 16.1917C14.6585 15.5439 13.7798 15.1799 12.8636 15.1799H5.95455C5.03834 15.1799 4.15967 15.5439 3.51181 16.1917C2.86396 16.8396 2.5 17.7183 2.5 18.6345V20.3617"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4531 4.92847C16.1962 5.11873 16.8548 5.55089 17.3252 6.15683C17.7955 6.76276 18.0508 7.508 18.0508 8.27506C18.0508 9.04211 17.7955 9.78735 17.3252 10.3933C16.8548 10.9992 16.1962 11.4314 15.4531 11.6216"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.40767 11.7254C11.3156 11.7254 12.8622 10.1787 12.8622 8.27083C12.8622 6.36294 11.3156 4.81628 9.40767 4.81628C7.49978 4.81628 5.95312 6.36294 5.95312 8.27083C5.95312 10.1787 7.49978 11.7254 9.40767 11.7254Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const orderIcon = (isActive) => {
  const strokeColor = isActive ? "white" : "black";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8984 3.08887H6.29844C5.79453 3.08887 5.31125 3.28905 4.95493 3.64536C4.59862 4.00168 4.39844 4.48496 4.39844 4.98887V20.1889C4.39844 20.6928 4.59862 21.1761 4.95493 21.5324C5.31125 21.8887 5.79453 22.0889 6.29844 22.0889H17.6984C18.2023 22.0889 18.6856 21.8887 19.0419 21.5324C19.3983 21.1761 19.5984 20.6928 19.5984 20.1889V8.78887L13.8984 3.08887Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7992 17.3389H8.19922"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7992 13.5388H8.19922"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0992 9.73877H9.14922H8.19922"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8984 3.08887V8.78887H19.5984"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const walletIcon = (isActive) => {
  const strokeColor = isActive ? "white" : "black";

  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 3.60474C3.96957 3.60474 3.46086 3.81545 3.08579 4.19052C2.71071 4.5656 2.5 5.0743 2.5 5.60474V19.6047C2.5 20.1352 2.71071 20.6439 3.08579 21.0189C3.46086 21.394 3.96957 21.6047 4.5 21.6047H18.5C19.0304 21.6047 19.5391 21.394 19.9142 21.0189C20.2893 20.6439 20.5 20.1352 20.5 19.6047V17.3247C20.8023 17.1502 21.0536 16.8996 21.2291 16.5979C21.4045 16.2962 21.4979 15.9538 21.5 15.6047V9.60474C21.4979 9.25571 21.4045 8.91331 21.2291 8.61157C21.0536 8.30983 20.8023 8.05925 20.5 7.88474V5.60474C20.5 5.0743 20.2893 4.5656 19.9142 4.19052C19.5391 3.81545 19.0304 3.60474 18.5 3.60474H4.5ZM4.5 5.60474H18.5V7.60474H12.5C11.9696 7.60474 11.4609 7.81545 11.0858 8.19052C10.7107 8.5656 10.5 9.0743 10.5 9.60474V15.6047C10.5 16.1352 10.7107 16.6439 11.0858 17.0189C11.4609 17.394 11.9696 17.6047 12.5 17.6047H18.5V19.6047H4.5V5.60474ZM12.5 9.60474H19.5V15.6047H12.5V9.60474ZM15.5 11.1047C15.1022 11.1047 14.7206 11.2628 14.4393 11.5441C14.158 11.8254 14 12.2069 14 12.6047C14 13.0026 14.158 13.3841 14.4393 13.6654C14.7206 13.9467 15.1022 14.1047 15.5 14.1047C15.8978 14.1047 16.2794 13.9467 16.5607 13.6654C16.842 13.3841 17 13.0026 17 12.6047C17 12.2069 16.842 11.8254 16.5607 11.5441C16.2794 11.2628 15.8978 11.1047 15.5 11.1047Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export const promotionIcon = (isActive) => {
  const strokeColor = isActive ? "white" : "black";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 17.1047C8.25 17.1047 15.25 18.1047 18.25 21.1047H19.25C19.5152 21.1047 19.7696 20.9994 19.9571 20.8118C20.1446 20.6243 20.25 20.37 20.25 20.1047V14.0417C20.6798 13.9312 21.0606 13.681 21.3325 13.3303C21.6044 12.9796 21.752 12.5485 21.752 12.1047C21.752 11.661 21.6044 11.2299 21.3325 10.8792C21.0606 10.5285 20.6798 10.2782 20.25 10.1677V4.10474C20.25 3.83952 20.1446 3.58517 19.9571 3.39763C19.7696 3.21009 19.5152 3.10474 19.25 3.10474H18.25C15.25 6.10474 8.25 7.10474 8.25 7.10474H4.25C3.71957 7.10474 3.21086 7.31545 2.83579 7.69052C2.46071 8.0656 2.25 8.5743 2.25 9.10474V15.1047C2.25 15.6352 2.46071 16.1439 2.83579 16.5189C3.21086 16.894 3.71957 17.1047 4.25 17.1047H5.25L6.25 22.1047H8.25V17.1047ZM10.25 8.76574C10.933 8.61974 11.777 8.41574 12.69 8.14874C14.368 7.65474 16.5 6.87774 18.25 5.67874V18.5297C16.5 17.3317 14.367 16.5547 12.69 16.0607C11.8846 15.8253 11.0707 15.6199 10.25 15.4447V8.76474V8.76574ZM4.25 9.10474H8.25V15.1047H4.25V9.10474Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export const wishlistIcon = (isActive) => {
  const strokeColor = isActive ? "white" : "black";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65 12.1797H14.35M11.5 9.32974V15.0297M7.225 4.10474C4.33938 4.10474 2 6.44411 2 9.32974C2 14.5547 8.175 19.3047 11.5 20.4096C14.825 19.3047 21 14.5547 21 9.32974C21 6.44411 18.6606 4.10474 15.775 4.10474C14.008 4.10474 12.4452 4.98206 11.5 6.32489C11.0182 5.63861 10.3781 5.07853 9.63398 4.69207C8.88983 4.30561 8.06352 4.10414 7.225 4.10474Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const securityIcon = (isActive) => {
  const strokeColor = isActive ? "white" : "black";
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8984 3.08887H6.29844C5.79453 3.08887 5.31125 3.28905 4.95493 3.64536C4.59862 4.00168 4.39844 4.48496 4.39844 4.98887V20.1889C4.39844 20.6928 4.59862 21.1761 4.95493 21.5324C5.31125 21.8887 5.79453 22.0889 6.29844 22.0889H17.6984C18.2023 22.0889 18.6856 21.8887 19.0419 21.5324C19.3983 21.1761 19.5984 20.6928 19.5984 20.1889V8.78887L13.8984 3.08887Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7992 17.3389H8.19922"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7992 13.5388H8.19922"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0992 9.73877H9.14922H8.19922"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8984 3.08887V8.78887H19.5984"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const logoutIcon = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 12.499L19 12.499M19 12.499L17 10.499M19 12.499L17 14.499M15 16.499L15 19.499C15 20.6036 14.1046 21.499 13 21.499L7 21.499C5.89543 21.499 5 20.6036 5 19.499L5 5.49902C5 4.39445 5.89543 3.49902 7 3.49902L13 3.49902C14.1046 3.49902 15 4.39445 15 5.49902L15 8.49902"
      stroke="#1F1F22"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
